import React from "react";
import ReactDOM from "react-dom";
import App from "./containers/App";

import { applyMiddleware, createStore } from "redux";
import thunkMiddleware from "redux-thunk";
import appStore from "./reducers";
import { Provider } from "react-redux";
import logger from "redux-logger";

// stores the current state of the gui application
let store = createStore(
	appStore,
	applyMiddleware(
		// lets us dispatch() functions
		thunkMiddleware,
		logger
	)
);

ReactDOM.render(
	<Provider store={store}>
		<App/>
	</Provider>,
	document.getElementById( "root" )
);
